import axios from "axios";

export const API_URL = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}/api`;

export const API = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

let refreshing = null;

API.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !(original.url || "").includes("/auth/")
    ) {
      original._retry = true;
      try {
        refreshing = refreshing || API.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return API(original);
      } catch (e) {
        // refresh failed
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(error, fallback = "Si è verificato un errore. Riprova.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return fallback;
}
